// Файл frontend_recovery.js

import { session_storage } from './session_storage';



const RELOAD_KEY = 'potale_frontend_recovery_reload';
const RECOVERY_WINDOW_MS = 60 * 1000;

const is_asset_error = (value) => {
    const text = String(value?.message || value || '').toLowerCase();
    return (
        text.includes('chunkloaderror')
        || text.includes('loading chunk')
        || text.includes('failed to fetch dynamically imported module')
        || text.includes('unexpected token')
        || text.includes('empty restored page')
    );
};

const can_reload_once = () => {
    try {
        const previous = Number(session_storage.get_item(RELOAD_KEY) || 0);
        if (Date.now() - previous < RECOVERY_WINDOW_MS) {
            return false;
        }
        session_storage.set_item(RELOAD_KEY, String(Date.now()));
        return true;
    } catch (error) {
        return true;
    }
};

export const recover_frontend_once = (error) => {
    if (!is_asset_error(error) || !can_reload_once()) {
        return false;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('__potale_recover', String(Date.now()));
    window.location.replace(url.toString());
    return true;
};

export const install_frontend_recovery = () => {
    window.addEventListener('error', (event) => {
        const target = event.target;
        const asset_failed = target instanceof HTMLScriptElement
            || target instanceof HTMLLinkElement;
        recover_frontend_once(asset_failed ? target?.src || target?.href : event.error);
    }, true);

    window.addEventListener('unhandledrejection', (event) => {
        recover_frontend_once(event.reason);
    });

    window.addEventListener('pageshow', (event) => {
        if (!event.persisted) {
            return;
        }

        const root = document.getElementById('root');
        const has_content = Boolean(
            root?.childElementCount || root?.textContent?.trim(),
        );

        if (!has_content) {
            recover_frontend_once(new Error('empty restored page'));
        }
    });
};
